export { default } from './SpaStaysDetailPage';
